import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  OutlinedInput,
  IconButton,
  InputAdornment,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import SvgIcon from "@mui/material/SvgIcon";

import { useLocation, useNavigate } from "react-router-dom";
import images from "../../../global-styles/images";

import { apiChatUrl } from "../../../utils/config/host-urls";
import ChatbotDefaultIcon from "./GeneralPreview/ChatbotBody/ChatbotDefaultIcon";

// const location = useLocation();
const PlaygroundChatPreview = (props: any) => {
  const {
    productParams,
    ChatSessionuuid,
    chatbotAppearance,
    chatbotSettings,
    wcmsg,
  } = props;
  const navigate = useNavigate();
  const [input, setInput] = useState("");
  const [IsTyping, setIsTyping] = useState(false);
  const [typedisabled, settypedisabled] = useState(false);
  const [QuickButtons, setQuickButtons] = useState(false);
  const [isOpenReplyForm, setisOpenReplyForm] = useState(false);
  const [TempInputValue, setTempInputValue] = useState("");
  // const [ChatSessionuuid, setChatSessionuuid] = useState("");
  // const [productParamsData, setproductParamsData] = useState<any>("");

  let productParamsData: any = "";
  const getLocation: any = useLocation();
  if (productParams) {
    productParamsData = productParams;
  }

  // useEffect(() => {
  //   setChatSessionuuid(GenerateUUID());
  // }, []);
  const GenerateUUID = () => {
    // xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    return (
      "session_id_" +
      "xxxxxx_xxxxx_xxxx_yxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      })
    );
  };
  const renderChatTime = () => {
    const d = new Date(),
      h = (d.getHours() < 10 ? "0" : "") + d.getHours(),
      m = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();
    return h + ":" + m;
  };
  const [messages, setMessages] = useState([
    {
      text: productParamsData?.chatAgentSettings?.welcomeMsg,
      sender: "bot",
      typing: false,
      time: renderChatTime(),
    },
  ]);
  // useEffect(() => {
  //   const wcmsg = {
  //     text: chatbotSettings.welcomeMsg,
  //     sender: "bot",
  //     typing: false,
  //     time: renderChatTime(),
  //   };
  //   setMessages([wcmsg]);
  // }, [chatbotSettings.welcomeMsg]);
  const handleInputChange = (event: any) => {
    setInput(event.target.value);
  };
  const handleSend = () => {
    if (input.trim() !== "") {
      settypedisabled(true);
      userMessageAppend(input);
      botMessageTypingAppend(input);
      setTempInputValue(input);
      setInput("");
    }
  };
  const handleEnter = (e: any) => {
    if (e.code === "Enter") {
      if (input.trim() !== "") {
        settypedisabled(true);
        userMessageAppend(input);
        botMessageTypingAppend(input);
        setTempInputValue(input);
        setInput("");
      }
    }
  };

  const userMessageAppend = (inputValue: any) => {
    const userMsgObj = {
      text: inputValue,
      sender: "user",
      typing: false,
      time: renderChatTime(),
    };
    setMessages([...messages, userMsgObj]);
  };
  const botMessageTypingAppend = (inputValue: any) => {
    const typingObj = {
      text: "",
      sender: "bot",
      typing: true,
      time: renderChatTime(),
    };
    setMessages((prevState) => [...prevState, typingObj]);
  };
  useEffect(() => {
    if (Array.isArray(messages) && messages.length > 0) {
      const lastItem = messages[messages.length - 1];
      const lastItemIndex = messages.length - 1;
      if (lastItem.sender === "bot" && lastItem.typing === true) {
        const newArr = [...messages];
        newArr.splice(lastItemIndex, 1);
        botMessageAppend(newArr);
      }
      const messagesContainer: any = document.getElementById(
        "cuvo-chat-messages-prev"
      );
      messagesContainer.scrollTop =
        messagesContainer.scrollHeight + messagesContainer.clientHeight;
    }
  }, [messages]);

  const botMessageAppend = async (newMessages: any) => {
    try {
      const response = await fetchWithTimeout(
        `${apiChatUrl}/chat`,
        //        "https://chatbackend.cuvo.io/chat",
        {
          timeout: 120000,
          method: "POST",
          // Adding body or contents to send
          body: JSON.stringify({
            message: TempInputValue,
            session_id: ChatSessionuuid,
            product_id: productParamsData?.id,
            product_version: productParamsData?.version,
            org_id: productParamsData?.orgId,
          }),
          // Adding headers to the request
          headers: {
            "Content-Type": "application/json",
          },
        }
      ) // Converting to JSON
        .then((response: any) => response.json())
        // Displaying results to console
        .then((json: any) => {
          // setQuickButtons(true);

          if (json.response.trigger_ticket_message) {
            setQuickButtons(true);
          }
          const testdata1 =
            "Ah, you're interested in cameras! 📸 Here are some popular camera brands that you might find interesting:\n1. Canon 📷: Known for their excellent image quality and wide range of options.\n2. Nikon 📸: Trusted by professionals and hobbyists alike for their advanced features.\n3. Sony 📹: Renowned for their mirrorless cameras and cutting-edge technology.\n4. Fujifilm 📸: Loved for their retro designs and fantastic image quality.\n5. GoPro 🎥: Perfect for capturing your adventures with their durable and compact action cameras.\nRemember, this is just a taste of what's out there! Let me know if you have any specific preferences or if there's anything else I can help you with. 😊 Absolutely! Here's a YouTube link to a compilation of funny videos that will surely bring a smile to your face: \n[https://www.youtube.com/watch?v=dQw4w9WgXcQ](demo:https://www.youtube.com/watch?v=dQw4w9WgXcQ)  😉 Enjoy the laughter! Fall Detect by KamiCare is a wonderful tool that provides crucial information about the time, location, and activity related to a fall. It helps you and your family members better understand the root cause of a fall and prevent future accidents. 🚨✨\nSome of its features include:\n- 24/7 fall detection, even in low-light conditions.\n- Real-time alerts with no false ones.\n- Live view of the room on your mobile device.\n- Two-way communication to check on your loved ones instantly.\n- Unlimited user sharing to authorize others to receive alerts and communicate directly. 🌐🏠\nPlease note, the Fall Detect Camera Sensor will NOT work without a Fall Detect subscription. You can purchase it [here](https://kamihome.com/fall-detect/).\n Sources: ['INTELLIGENCE LAYER: If question is about camera issues or camera troubleshooting or camera operation on but didn't contain camera name or camera model.']";

          const testdata =
            "Sure, I'd be happy to help with that! 😊\n\nYI offers different cloud plans to choose from. The main differences are between the Motion Detected service and the CVR (continuous video recording) service:\n- With the Motion Detected service, the camera uploads to the cloud when it detects motion.\n- With CVR, the camera uploads everything to the cloud.\n\nCloud plans are also based on:\n- How long the recordings are stored in the cloud (7, 15, or 30 days).\n- The number of cameras you need to add to the cloud service (1 or 5 cameras).\n\nThe pricing of each plan depends on the type of plan (Motion or CVR), the storage duration, the number of supported cameras, and where the plans are purchased.\n\nYou can purchase a cloud subscription via the YI IOT app or the YI IOT website. If your balance is not enough for payment, your subscription will be canceled, and you'll need to start a new subscription.\n\nFor purchasing, you can visit: https://kamihome.com/Kami-cloud/\n\nI hope this helps! Let me know if you have any other questions. 😃\nSources: ['How To Purchase Cloud Service Plan Using Yi Iot App Ios Cleaned_.txt', 'What happens if I have subscribed to YI Cloud Service, but my balance is not enough for payment - YI Cloud_.txt', 'Cloud Plan Difference Cleaned_.txt', 'How To Purchase Cloud Subscription Via Yi Iot Website Cleaned_.txt', 'INTELLIGENCE LAYER: If the question is a talks about Pro Security, Cloud subscription, Fall detect, recommend the product and feature to the user for on but didn't']";

          const testdata5 =
            "Kami cameras are a range of smart security cameras offered by Yi Technology. They include the Kami Pro Security, Kami Doorbell Camera, Kami Outdoor Camera, and Kami Mini Camera. Here are some key points about each camera:\n\n- Kami Pro Security: It requires Wi-Fi with 2.4GHz and 802.11 b/g/n in your home to function properly. Wi-Fi is necessary for the cameras to work. [^1^]\n\n- Kami Doorbell Camera: It is a video doorbell camera that allows you to see and communicate with visitors at your door. You can view live video, receive motion alerts, and interact with visitors through the Kami Home app. [^2^]\n\n- Kami Outdoor Camera: It is a weatherproof security camera designed for outdoor use. It features 1080p resolution, night vision, two-way audio, and motion detection. It can be accessed and controlled through the Kami Home app. [^3^]\n\n- Kami Mini Camera: It is a compact indoor security camera that offers 1080p resolution, night vision, motion detection, and two-way audio. It can be placed anywhere in your home and monitored through the Kami Home app. [^4^]\n\nFor more detailed information about each camera, you can refer to the respective articles listed below.\n\n\nSources: ['[^1^]: [Kami Pro Security - Frequently Asked Questions - Is Wi-Fi necessary for the cameras to function in my home?](https://help.yitechnology.com/hc/en-us/articles/10609307591835-Do-I-need-Wi-Fi-in-my-home-for-the-cameras-to-work-)', '[^2^]: [Introduction to Kami Doorbell Camera](https://help.yitechnology.com/hc/en-us/articles/1260801414069-Getting-to-know-your-Doorbell-Camera)', '[^3^]: [Introduction to the Kami Outdoor Camera](https://help.yitechnology.com/hc/en-us/articles/126080341']";
          // const respData = json.response.response;
          // const respData = testdata5;
          const resp = json.response.response;

          let respData = "";

          if (resp != "") {
            respData = json.response.response;
          } else {
            respData =
              "Sorry we couldn't respond to your query. Could you please ask again or raise a ticket?";
          }

          const pattern1 =
            /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
          const str1 = respData.replace(
            pattern1,
            "<a style='color:#1b66e6;word-wrap: break-word;' target='_blank' href='$1'>$1</a>"
          );
          const pattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
          const str2 = str1.replace(
            pattern2,
            '$1<a style="color:#1b66e6;word-wrap: break-word;"  target="_blank" href="https://$2">https://$2</a>'
          );

          // const sourcePattern = /Source(?:s|):\s*\[(.*?)\]/;
          const sourcePattern = /Sources:(.*)/;
          const withoutSourcedata = str2.replace(sourcePattern, "");

          const data = str2.replace(/\n/g, "<li class='bot-side-msg'>");
          // const appendTo = formattedResponse(data);
          const appendTo = formattedResponse(respData);

          const botMsgobj = {
            // text: str2.replace(/\n/g, "<li class='bot-cuvo-list'>"),
            text: (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    withoutSourcedata.replace(
                      /\n/g,
                      "<li class='bot-side-msg'>"
                    ) +
                    "" +
                    appendTo,
                  // __html: appendTo,
                }}
              ></div>
            ),
            sender: "bot",
            typing: false,
            time: renderChatTime(),
          };
          setMessages([...newMessages, botMsgobj]);
          settypedisabled(false);
        });
    } catch (error) {
      const botMsgobj = {
        text: "Sorry we couldn't respond to your query. Could you please ask again or raise a ticket?",
        sender: "bot",
        typing: false,
        time: renderChatTime(),
      };
      setMessages([...newMessages, botMsgobj]);
      settypedisabled(false);
    }
  };
  const formattedResponse = (data: any) => {
    return sourceFiles(data);
  };
  const sourceFiles = (data_: any) => {
    const data =
      "Sure, I'd be happy to help with that! 😊\n\nYI offers different cloud plans to choose from. The main differences are between the Motion Detected service and the CVR (continuous video recording) service:\n- With the Motion Detected service, the camera uploads to the cloud when it detects motion.\n- With CVR, the camera uploads everything to the cloud.\n\nCloud plans are also based on:\n- How long the recordings are stored in the cloud (7, 15, or 30 days).\n- The number of cameras you need to add to the cloud service (1 or 5 cameras).\n\nThe pricing of each plan depends on the type of plan (Motion or CVR), the storage duration, the number of supported cameras, and where the plans are purchased.\n\nYou can purchase a cloud subscription via the YI IOT app or the YI IOT website. If your balance is not enough for payment, your subscription will be canceled, and you'll need to start a new subscription.\n\nFor purchasing, you can visit: https://kamihome.com/Kami-cloud/\n\nI hope this helps! Let me know if you have any other questions. 😃\nSources: ['How To Purchase Cloud Service Plan Using Yi Iot App Ios Cleaned_.txt', 'What happens if I have subscribed to YI Cloud Service, but my balance is not enough for payment - YI Cloud_.txt', 'Cloud Plan Difference Cleaned_.txt', 'How To Purchase Cloud Subscription Via Yi Iot Website Cleaned_.txt', 'INTELLIGENCE LAYER: If the question is a talks about Pro Security, Cloud subscription, Fall detect, recommend the product and feature to the user for kjgea']";

    const data1 =
      "You can contact support by sending an email to support@kamihome.com. They can help you with issues related to your order, if you believe your account has been compromised, or if you wish to initiate a refund.\n\nSources: ['I have an issue with my order. - General_.txt', 'General Hacked Account Cleaned_.txt', 'To Get Refund Cleaned_.txt']";

    const data2 =
      "To assist you better, could you please specify the model of your camera? Here are the options,\n        Cameras:\n        * List of Indoor Cameras:\n            - YI Home Camera.\n            - YI 1080p Home Camera.\n            - Kami Fall Detection Camera.\n            - Kami Mini Camera.\n            - YI 1080p Dome Camera.\n            - YI Dome X.\n            - Kami Indoor Camera.\n            - YI Dome Guard.\n            - YI Dome U.\n            - Kami Baby Smart Monitor.\n            - Kami Doorbell Camera.\n        * List of Outdoor Cameras:\n            - YI Outdoor Camera 1080p.\n            - YI 1080P Outdoor PTZ Camera.\n        * List of Wire-Free Camera:\n            - Kami Wire-Free Outdoor Camera.\n Sources: ['INTELLIGENCE LAYER: If question is about camera issues or camera troubleshooting or camera operation on but didn't contain camera name or camera model.']";

    let sources = "";
    try {
      // const pattern: any = /Source(?:s|):\s*\[(.*?)\]/;
      // const match: any = data_.match(pattern);
      const pattern: any = /Sources:(.*)/;
      const match: any = pattern.exec(data_);

      if (match) {
        // let a: any = "[" + match[1] + "]";
        let a: any = match[1];

        a = a.replace(/'/g, '"');

        // a = JSON.parse(a);

        let updated_str = "";
        const regex = /^[a-zA-Z]+$/;
        // Find indices of double quotes (")
        for (let i = 0; i < a.length; i++) {
          if (a[i] === '"' && regex.test(a[i - 1]) && regex.test(a[i + 1])) {
            updated_str += "\\" + a[i];
          } else {
            updated_str += a[i];
          }
        }
        a = JSON.parse(updated_str);

        sources = "- " + a.map((file: any) => file.trim()).join("<br>- ");
        // data_ = data_.replace(match[0], "").trim();
        data_ =
          "<p class='bot-sources-ptext-prev'>\n Referred sources:\n</p>" +
          "<p class='bot-sources-p-prev'>" +
          sources +
          "</p>";
      } else {
        data_ =
          "<p class='bot-sources-ptext-prev'>\n Referred sources:\n</p>" +
          "<p class='bot-sources-p-prev'>\n- General Question, No KB Articles</p>";
      }
    } catch (error) {}
    const pattern1 =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    const str1 = data_.replace(
      pattern1,
      "<a style='color:#1b66e6;word-wrap: break-word;' target='_blank' href='$1'>$1</a>"
    );
    const pattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    const str2 = str1.replace(
      pattern2,
      '$1<a style="color:#1b66e6;word-wrap: break-word;"  target="_blank" href="https://$2">https://$2</a>'
    );
    return str2;
    // return data_;
  };
  async function fetchWithTimeout(resource: any, options: any) {
    const { timeout = 120000 } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);
    return response;
  }

  const handleQuickButtonClicked = (data: any) => {
    if (data == "No") {
      setQuickButtons(false);
      settypedisabled(false);
    } else if (data == "Yes") {
      settypedisabled(false);
      setQuickButtons(false);
      setisOpenReplyForm(true);
    }
  };
  const handleCloseReplyForm = () => {
    setisOpenReplyForm(false);
  };
  const handleSendreplyForm = () => {
    setisOpenReplyForm(false);
    const botMsgobj = {
      text: "Your ticket has been successfully filed. You will receive an email confirmation shortly.",
      sender: "bot",
      typing: false,
      time: renderChatTime(),
    };
    setMessages([...messages, botMsgobj]);
  };
  const [svgSendContent, setsvgSendContent] = useState<any>(null);

  useEffect(() => {
    const fetchSendiconSvg = async () => {
      const imgPath = chatbotSettings.sendIcon ? chatbotSettings.sendIcon : "";
      // "https://dashboard-cuvo-upload-photos.s3.amazonaws.com/product_6d414070-8396-11ee-a0ed-f3e6d67f790f/Demo1/logo.png";
      const fileExtension = getFileExtension(imgPath);
      if (fileExtension != "svg") {
        setsvgSendContent(
          chatbotSettings.sendIcon ? chatbotSettings.sendIcon : ""
        );
      } else {
        try {
          const response = await fetch(
            chatbotSettings.sendIcon ? chatbotSettings.sendIcon : ""
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG. Status: ${response.status}`);
          }
          const svgText = await response.text();
          setsvgSendContent(`data:image/svg+xml;base64,${btoa(svgText)}`);
        } catch (error) {
          // console.error("Error fetching SVG:", error);
        }
      }
    };

    fetchSendiconSvg();
  }, [chatbotSettings]);
  const getFileExtension = (url: any) => {
    const parts = url.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1];
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return null;
    }
  };
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        // bgcolor: isOpenReplyForm ? "#fff" : f",
      }}
    >
      {!isOpenReplyForm && (
        <>
          <Box
            sx={{
              flexGrow: 1,
              height: "200px",
              overflow: "auto",
              p: "27px 10px",
              background: "#eeecec",
            }}
            id="cuvo-chat-messages-prev"
          >
            {messages.map((message) => (
              <Message
                message={message}
                productParamsData={productParamsData}
                chatbotAppearance={chatbotAppearance}
                chatbotSettings={chatbotSettings}
              />
            ))}
          </Box>
          {QuickButtons && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  borderRadius: "4px !important",
                  margin: 1,
                  border: "none",
                  ":hover": {
                    boxShadow: "none",
                    bgcolor:
                      chatbotAppearance &&
                      chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  },
                  background:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  boxShadow: 0,
                  color:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-text-color"],
                  fontSize: "12px",
                  textTransform: "unset",
                }}
                variant="outlined"
                onClick={() => handleQuickButtonClicked("Yes")}
              >
                Yes, Raise a Ticket
              </Button>
              <Button
                sx={{
                  borderRadius: "4px !important",
                  border: "none",
                  ":hover": {
                    boxShadow: "none",
                    bgcolor:
                      chatbotAppearance &&
                      chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  },
                  background:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  boxShadow: 0,
                  color:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-text-color"],
                  fontSize: "12px",
                  textTransform: "unset",
                }}
                variant="outlined"
                onClick={() => handleQuickButtonClicked("No")}
              >
                No,Thank you
              </Button>{" "}
            </Box>
          )}
          <Box sx={{ p: "12px 10px", backgroundColor: "#eeecec" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} className="input-chabot-griditem">
                <Grid container item xs={12} mt="20px">
                  <TextField
                    className="chat-prev-input-user"
                    variant="outlined"
                    fullWidth
                    value={input}
                    onChange={handleInputChange}
                    onKeyDown={handleEnter}
                    disabled={typedisabled}
                    sx={{
                      // background: chatbotAppearance?.["cuvo-chatbot-input-bg-color"],
                      // // borderColor: chatbotAppearance?.["cuvo-chatbot-input-text-color"],
                      // ...inputFontSettings,
                      "& .MuiOutlinedInput-root:hover": {
                        "& > fieldset": {
                          borderColor: "#ccc",
                        },
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            sx={{
                              width: "30px",
                              height: "30px",
                              background: "none",
                              // chatbotAppearance?.["cuvo-chatbot-send-icon-bg-color"],
                              borderRadius: "50%",
                              display: "grid",
                              placeContent: "center",
                              "&:hover": {
                                background: "none",
                                // chatbotAppearance?.["cuvo-chatbot-send-icon-bg-color"],
                              },
                            }}
                          >
                            {!chatbotSettings.sendIcon && (
                              <SvgIcon onClick={handleSend}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="16"
                                  viewBox="0 0 19 16"
                                  fill="#2858D3"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M9.444 4.31755C4.39964 6.69157 0.235955 8.66188 0.191327 8.69602C0.1467 8.73019 0.0833707 8.81435 0.0505535 8.88307C0.00167241 8.98553 -0.00666851 9.03034 0.00423885 9.13178C0.0193998 9.27267 0.106801 9.43303 0.205015 9.50009C0.334406 9.58846 5.11558 11.7588 5.14046 11.7404C5.15425 11.7303 7.1545 10.1542 9.58549 8.23799C12.0165 6.32182 14.1552 4.63603 14.3381 4.49181C14.66 4.23813 14.6341 4.2653 13.5421 5.3274C12.9213 5.9312 11.0412 7.74817 9.36413 9.36515L6.31494 12.3051L6.38184 12.3379C6.41862 12.3559 7.78696 12.9822 9.42259 13.7297C12.3137 15.0508 12.4003 15.0887 12.5356 15.0882C12.711 15.0875 12.845 15.0307 12.9477 14.9133C13.0097 14.8425 13.6492 13.3168 15.994 7.64491C17.6262 3.69661 18.974 0.423725 18.9889 0.371845C19.0423 0.186573 18.8959 -0.00252739 18.7011 2.55633e-05C18.6368 0.000891744 16.3336 1.07512 9.444 4.31755ZM6.31803 14.5714C6.31803 15.6808 6.32098 15.7671 6.36145 15.8395C6.38533 15.8822 6.44132 15.9359 6.48585 15.9588C6.64059 16.0384 6.68653 16.0223 7.13183 15.7326C8.52821 14.8241 8.90279 14.5741 8.88853 14.5598C8.87385 14.5452 6.80763 13.5948 6.46655 13.4459L6.31803 13.381V14.5714Z"
                                    fill="#2858D3"
                                  />
                                </svg>
                              </SvgIcon>
                              // <SendIcon
                              //   onClick={handleSend}
                              //   sx={{ color: "#2858D3" }}
                              //   // color={
                              //   //   chatbotAppearance?.[
                              //   //     "cuvo-chatbot-send-icon-fg-color"
                              //   //   ]
                              //   // }
                              // />
                            )}
                            {chatbotSettings.sendIcon && (
                              // <img
                              //   src={`data:image/svg+xml;utf8,${encodeURIComponent(
                              //     newSendIcon!
                              //   )}`}
                              //   alt="Send Icon"
                              // />
                              <img
                                onClick={handleSend}
                                style={{ width: "60px" }}
                                // src={chatbotSettings.sendIcon}
                                src={svgSendContent}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
              {/* <Grid item xs={2}>
                <Button
                  fullWidth
                  color="primary"
                  variant="contained"
                  endIcon={<SendIcon />}
                  onClick={handleSend}
                  disabled={typedisabled}
                >
                  Send
                </Button>
              </Grid> */}
            </Grid>
          </Box>
        </>
      )}
      {isOpenReplyForm && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Grid container sx={{ p: "10px" }} spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography sx={{ fontSize: "13px" }}>
                Sorry that we couldn’t resolve the issue. I can have our
                customer success manager help you. Please provide the following
                information:
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    First name
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value=""
                    // onChange={handleFirstName}
                    id="fname-input"
                    label="First Name"
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>Last name</InputLabel>
                  <OutlinedInput
                    type="text"
                    value=""
                    // onChange={handleLastName}
                    id="lname-input"
                    label="Last Name"
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={12}>
              <Box>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>Email address</InputLabel>
                  <OutlinedInput
                    type="text"
                    value=""
                    id="email-input"
                    // onChange={handleEmailChange}
                    label="Email Address"
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={12}>
              <Box>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>Mobile Number</InputLabel>
                  <OutlinedInput
                    type="text"
                    value=""
                    id="mobile-input"
                    // onChange={handleEmailChange}
                    label="Mobile No"
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={12}>
              <Box>
                <FormControl
                  className="custom-select custom-textarea"
                  fullWidth
                >
                  <InputLabel>Comments</InputLabel>
                  <OutlinedInput
                    type="textarea"
                    value=""
                    id="comments-input"
                    // onChange={handleEmailChange}
                    label="Comments"
                    sx={{ height: "100px" }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box></Box>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
            className="footer-action-btn"
          >
            <>
              <Button
                variant="outlined"
                sx={{
                  borderRadius: "4px !important",
                  margin: 1,
                  border: "none",
                  ":hover": {
                    boxShadow: "none",
                    bgcolor:
                      chatbotAppearance &&
                      chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  },
                  background:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  boxShadow: 0,
                  color:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-text-color"],
                  fontSize: "12px",
                  textTransform: "unset",
                }}
                onClick={handleCloseReplyForm}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  borderRadius: "4px !important",
                  margin: 1,
                  border: "none",
                  ":hover": {
                    boxShadow: "none",
                    bgcolor:
                      chatbotAppearance &&
                      chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  },
                  background:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                  boxShadow: 0,
                  color:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-text-color"],
                  fontSize: "12px",
                  textTransform: "unset",
                }}
                onClick={handleSendreplyForm}
              >
                Send
              </Button>{" "}
            </>
          </Box>{" "}
        </Box>
      )}
    </Box>
  );
};

const Message = (data: any) => {
  const productParamsData = data.productParamsData;
  const isBot = data.message.sender === "bot";
  const isTyping = data.message.typing;
  const chatbotAppearance = data.chatbotAppearance;
  const chatbotSettings = data.chatbotSettings;
  const renderChatTime = () => {
    const d = new Date(),
      h = (d.getHours() < 10 ? "0" : "") + d.getHours(),
      m = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();
    return h + ":" + m;
  };
  const renderFontSettings = () => {
    const userFontSettings = {
      color: chatbotAppearance?.["cuvo-chatbot-user-text-color"],
      fontFamily: chatbotAppearance?.["cuvo-chatbot-user-text-font-family"],
      fontWeight: chatbotAppearance?.["cuvo-chatbot-user-text-font-weight"],
      fontStyle: chatbotAppearance?.["cuvo-chatbot-user-text-font-style"],
      fontSize: chatbotAppearance?.["cuvo-chatbot-user-text-font-size"],
    };

    const botFontSettings = {
      color: chatbotAppearance?.["cuvo-chatbot-bot-text-color"],
      fontFamily: chatbotAppearance?.["cuvo-chatbot-bot-text-font-family"],
      fontWeight: chatbotAppearance?.["cuvo-chatbot-bot-text-font-weight"],
      fontStyle: chatbotAppearance?.["cuvo-chatbot-bot-text-font-style"],
      fontSize: chatbotAppearance?.["cuvo-chatbot-bot-text-font-size"],
    };

    const inputFontSettings = {
      color: chatbotAppearance?.["cuvo-chatbot-input-text-color"],
      fontFamily: chatbotAppearance?.["cuvo-chatbot-input-text-font-family"],
      fontWeight: chatbotAppearance?.["cuvo-chatbot-input-text-font-weight"],
      fontStyle: chatbotAppearance?.["cuvo-chatbot-input-text-font-style"],
      fontSize: chatbotAppearance?.["cuvo-chatbot-input-text-font-size"],
    };

    return isBot ? botFontSettings : userFontSettings;
  };

  const [svgContent, setSvgContent] = useState<any>(null);

  useEffect(() => {
    const fetchSvg = async () => {
      const imgPath = chatbotSettings.chatbotIcon
        ? chatbotSettings.chatbotIcon
        : "";
      // "https://dashboard-cuvo-upload-photos.s3.amazonaws.com/product_6d414070-8396-11ee-a0ed-f3e6d67f790f/Demo1/logo.png";
      const fileExtension = getFileExtension(imgPath);
      if (fileExtension != "svg") {
        setSvgContent(
          chatbotSettings.chatbotIcon ? chatbotSettings.chatbotIcon : ""
        );
      } else {
        try {
          const response = await fetch(
            chatbotSettings.chatbotIcon ? chatbotSettings.chatbotIcon : ""
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG. Status: ${response.status}`);
          }
          const svgText = await response.text();
          setSvgContent(`data:image/svg+xml;base64,${btoa(svgText)}`);
        } catch (error) {
          // console.error("Error fetching SVG:", error);
        }
      }
    };

    fetchSvg();
  }, [chatbotSettings]);

  const getFileExtension = (url: any) => {
    const parts = url.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1];
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isBot ? "flex-start" : "flex-end",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isBot ? "row" : "row-reverse",
          alignItems: "center",
        }}
      >
        <Avatar
          sx={{
            top: "-20px",
            background: "none !important",
            width: "30px",
            height: "30px",
          }}
        >
          {isBot ? (
            chatbotSettings.chatbotIcon ? (
              <img
                style={{
                  background: "none !important",
                  width: "30px",
                  height: "30px",
                }}
                // src={chatbotSettings.chatbotIcon}
                src={svgContent}
              />
            ) : (
              <ChatbotDefaultIcon
                width="20px"
                // color={chatbotAppearance?.["cuvo-chatbot-bot-icon-fg-color"]}
              />
            )
          ) : (
            <img
              style={{
                background: "none !important",
                width: "30px",
                height: "30px",
              }}
              src="https://source.unsplash.com/user/c_v_r/500x500"
            />
          )}
        </Avatar>
        {/* <Typography sx={{ pl: 1 }}> */}{" "}
        {isBot && isTyping ? (
          <div className="typing-indicator">
            <span
              style={{
                background: `${chatbotAppearance["cuvo-chatbot-bot-bg-color"]}`,
              }}
            ></span>
            <span
              style={{
                background: `${chatbotAppearance["cuvo-chatbot-bot-bg-color"]}`,
              }}
            ></span>
            <span
              style={{
                background: `${chatbotAppearance["cuvo-chatbot-bot-bg-color"]}`,
              }}
            ></span>
          </div>
        ) : (
          ""
        )}
        {/* </Typography> */}
        {!isTyping && (
          <div className="chat-msg-timings">
            <Paper
              variant="outlined"
              sx={{
                display: "inline-block",
                maxWidth: "300px !important",
                p: 1,
                ml: isBot ? 1.5 : 0,
                mr: isBot ? 0 : 1.5,
                backgroundColor: isBot
                  ? chatbotAppearance?.["cuvo-chatbot-bot-bg-color"]
                  : chatbotAppearance?.["cuvo-chatbot-user-bg-color"],

                // backgroundColor: isBot
                //   ? productParamsData
                //     ? productParamsData?.chatAgentSettings
                //         ?.branding["cuvo-chatbot-bot-bg-color"]
                //     : "#fff"
                //   : productParamsData
                //   ? productParamsData?.chatAgentSettings?.branding[
                //       "cuvo-chatbot-user-bg-color"
                //     ]
                //   : "#DBDFE8",
                borderRadius: isBot ? "0px 8px 8px 8px" : "8px 0px 8px 8px",
              }}
            >
              <Typography
                sx={{
                  ...renderFontSettings(),
                }}
                variant="body1"
              >
                {data.message.text}
              </Typography>
            </Paper>
            <div className="chat-timings">{data.message.time}</div>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default PlaygroundChatPreview;
